import { render, staticRenderFns } from "./upFile.vue?vue&type=template&id=13e9c425&scoped=true"
import script from "./upFile.js?vue&type=script&lang=js&external"
export * from "./upFile.js?vue&type=script&lang=js&external"
import style0 from "./upFile.vue?vue&type=style&index=0&id=13e9c425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9c425",
  null
  
)

export default component.exports